import { createSelector } from "@reduxjs/toolkit";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectViewStates } from "views/logic/slices/viewSelectors";
const selectQueryTitles = createSelector(
  selectViewStates,
  (viewStates) => viewStates.map((viewState) => viewState.titles.getIn(["tab", "title"])).filter((v) => v !== void 0).toMap()
);
const useQueryTitles = () => useViewsSelector(selectQueryTitles);
export default useQueryTitles;
